import {collapseElement, expandElement, mediaQueryBreakpointMD} from "../Utils/Utils";

const Menu1 = () => {

	document.querySelectorAll('#menu-1 .menu > .menu-item, #menu-1-overlay .menu > .menu-item').forEach((menuItem) => {

		const subMenu = menuItem.querySelector('.sub-menu');
		if(subMenu) {

			// No touch devices
			menuItem.addEventListener('mouseover', (e) => {
				if(!Modernizr.touchevents && window.innerWidth >= mediaQueryBreakpointMD) {
					e.currentTarget.classList.add('js-reveal-sub-menu');
				}
			});
			menuItem.addEventListener('mouseleave', (e) => {
				if(!Modernizr.touchevents && window.innerWidth >= mediaQueryBreakpointMD) {
					e.currentTarget.classList.remove('js-reveal-sub-menu');
				}
			});

			// Touch devices
			menuItem.querySelector('a:first-child').addEventListener('click', (e) => {

				e.preventDefault();

				if(Modernizr.touchevents || window.innerWidth < mediaQueryBreakpointMD) {

					const menuItem = e.currentTarget.parentNode;

					if(menuItem.classList.contains('js-reveal-sub-menu') ||	( menuItem.classList.contains('current-menu-parent') && !menuItem.classList.contains('js-conceal-sub-menu'))) {

						collapseElement(subMenu, () => {
							menuItem.classList.remove('js-reveal-sub-menu');
							menuItem.classList.add('js-conceal-sub-menu');
						});
					}
					else {
						expandElement(subMenu, () => {
							menuItem.classList.add('js-reveal-sub-menu');
						});
					}
				}
			});
		}
	});
};

export default Menu1;